<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ffffff" title="绑定支付宝" left-arrow @click-left="$router.back()" />
      <div class="modal-body" style="    margin-top: 40px;    font-size: 12px;">
        <div class="content-box">
          <p class="tips-top">说明：<i>*</i> 为必填信息</p>
          <ul class="list">
            <li class="item">
              <div class="label_box"><label for=""><i>*</i>支付宝姓名</label>
                <input type="text" v-model="cardInfo.bank_owner" placeholder="姓名" required></div>
            </li>
            <li class="item">
              <div class="label_box"><label for=""><i>*</i>支付宝账号</label>
                <input type="text" v-model="cardInfo.bank_no" placeholder="11位手机号码或电子邮箱" required></div>
            </li>
            <li class="item">
              <div class="label_box"><label for=""><i>*</i>支付宝昵称</label>
                <input type="text" v-model="cardInfo.bank_address" placeholder="您的支付宝昵称" value="" required></div>
              <div class="tips_nick">注意：如修改昵称请及时更新，否则影响收款</div>
            </li>
            <li class="item">
              <div class="label_box">
                <div class="formField">
                  <label for="files">
                    <input id="files" type="file" @change="onchangemd" accept="image/png,image/jpg,image/jpeg">
                    <div v-if="!cardInfo.user_img" class="uploadButton"></div>
                    <img v-if="cardInfo.user_img" :src="cardInfo.user_img" class="preview-image" alt="上传的二维码">
                  </label>
                </div>
              </div>
              <p class="tips-text">* 点击上传支付宝收款二维码截图，支持png，jpg，jpeg格式</p>
              <p class="help-btn" @click="$parent.goNav('/wenInfo?id=29')">查看如何获取支付宝个人收款码</p>
            </li>
            <li class="item">
              <div class="label_box"><label for=""><i>*</i>支付密码</label>
                <input type="password" v-model="cardInfo.pay_pass" placeholder="支付密码" required></div>
            </li>
            <li class="item">
              <div class="btn" @click="bindCard"><span class="button next mgc">下一步</span></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'money',
  data() {
    return {
      daoTime: null,
      balancelist: [],
      zhanghuguanli: false,
      usercardLis: [],
      cardInfo: { user_img: '', bank: 'ZFB', pay_pass: '' },
    };
  },
  methods: {
    onchangemd(e) {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      this.$parent.showLoading();
      this.$apiFun.post('/api/uploadimgurl', formData)
          .then(res => {
            this.$parent.hideLoading();
            this.cardInfo.user_img = res;
          });
    },
    bindCard() {
      if (!this.cardInfo.bank_owner) {
        this.$parent.showTost(0, '请输入支付宝姓名');
        return;
      }
      if (!this.cardInfo.bank_address) {
        this.$parent.showTost(0, '请输入支付宝昵称');
        return;
      }
      if (!this.cardInfo.bank_no) {
        this.$parent.showTost(0, '请输入支付宝账号');
        return;
      }
      if (!this.cardInfo.user_img) {
        this.$parent.showTost(0, '请上传收款码');
        return;
      }
      if (!this.cardInfo.pay_pass) {
        this.$parent.showTost(0, '请输入支付密码');
        return;
      }
      if (this.cardInfo.bank_no.length < 8) {
        this.$parent.showTost(0, '请输入正确的卡号长度');
        return;
      }
      if (this.cardInfo.pay_pass.length < 6 || this.cardInfo.pay_pass.length > 18) {
        this.$parent.showTost(0, '请输入支付密码长度');
        return;
      }
      this.$parent.showLoading();
      this.$apiFun
          .post('/api/bindcard', this.cardInfo)
          .then(res => {
            if (res.code != 200) {
              this.$parent.showTost(0, res.message);
            }
            if (res.code == 200) {
              this.$parent.showTost(1, '绑定成功');
              this.$router.back();
            }
            this.$parent.hideLoading();
          })
          .catch(res => {
            this.$parent.hideLoading();
          });
    },
  },
  beforeDestroy() {
    if (this.daoTime) {
      clearInterval(this.daoTime);
    }
    this.daoTime = null;
  },
};
</script>
<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: flex-end;
  z-index: 100;
}

.modal-content {
  width: 100%;
  height: 100%;
  background: #fff;
  border-top-left-radius: 1.066667rem;
  border-top-right-radius: 1.066667rem;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  align-items: center;
  height: 2.4rem;
  padding: 0 1rem;
  background: #fff;
  border-bottom: 1px solid rgba(217, 217, 217, 0.22);
}

.back-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #000;
}

.modal-title {
  flex: 1;
  text-align: center;
  font-size: 1rem;
  color: #0c0319;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex: 1;
}

.content-box {
  background: #f7f7f7;
  height: 100%;
}

.tips-top {
  color: #ee5a5a;
  padding: 0.64rem 0.4rem;
  font-size: 0.74667rem;
}

.tips-top i {
  color: #ee5a5a;
}

.list {
  padding: 0.64rem 0.64rem 0;
}

.item {
  margin-bottom: 15px;
}

.label_box {
  display: flex;
  flex-direction: column;
  position: relative;
}

.label_box > label {
  color: #0c0319;
  font-size: 0.74667rem;
  margin: 0.6rem 0 0.4rem;
}

.label_box > label i {
  display: inline-block;
  margin-right: 5px;
  color: #7d558a;
}

.label_box > input {
  border: 1px solid #ccc;
  height: 2.13333rem;
  box-sizing: border-box;
  line-height: 2.13333rem;
  border-radius: 4px;
  padding: 0 0.53333rem;
}

.tips_nick {
  color: #ee5a5a;
  margin-top: 4px;
}

.formField {
  flex: 1;
  align-items: center;
  margin-bottom: 5px;
}

.formField label {
  position: relative;
  width: 5.33333rem;
  height: 5.33333rem;
  border-radius: 4px;
  border: 1px solid rgba(160, 149, 198, 0.2);
  display: block;
  background: #fafaff;
}

.formField input {
  opacity: 0;
  padding-left: 0;
  position: absolute;
  z-index: 10;
}

.uploadButton, .formField label img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 8;
}

.uploadButton {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1.38667rem;
  height: 1.38667rem;
  background: url(/webx/xc/mobile/svg/addImg.95ff.svg) no-repeat 50% / 100% 100%;
  pointer-events: none;
}

.preview-image {
  width: 100%;
  height: auto;
  max-height: 5.33333rem;
  object-fit: contain;
}

.tips-text {
  color: #545454;
  font-size: 0.64rem;
}

.help-btn {
  width: 10.24rem;
  height: 1.4rem;
  line-height: 1.4rem;
  border-radius: 1rem;
  text-align: center;
  background: linear-gradient(0deg, #5a436c, #815b82 53%, #91658c);
  color: #fff;
  margin-top: 0.4rem;
  font-size: 0.64rem;
}

.btn {
  display: flex;
  justify-content: center;
}

.button {
  display: inline-block;
  width: 44%;
  height: 2.4rem;
  line-height: 2.4rem;
  border: none;
  background: linear-gradient(0deg, #5a436c, #815b82 53%, #91658c);
  letter-spacing: 3px;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  border-radius: 0.3rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  .modal-content {
    width: 600px;
    margin: 0 auto;
  }
}
</style>